import React, { useState, useEffect } from "react";
import SimpleTextInput from "../../../ShareElements/TextInput/TextInputNolabel";
import SimpleTextArea from "../../../ShareElements/TextInput/TextAreaNolabel";
import Switch from "../../../ShareElements/TextInput/Switch";
import UnsavedChangesAlert from "../../../ShareElements/UnsavedChangesAlert/UnsavedChangesAlert";
import axios from "axios";
import { Config } from "../../../../../../Config";
import Rotator from "../../../../../../Assets/Images/ButtonLoadingIcon.svg";
import Select from "../../../ShareElements/Select/Select";

const BasicSettings = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  const [ChangesApplied, setChangesApplied] = useState(false);
  const [UnsavedChanges, setUnsavedChanges] = useState(false);
  const [SelectedProfile, setProfile] = useState({});
  const [ValidationError, setValidationError] = useState(
    translateText("fill_the_field_error") + "."
  );
  const [IsLoading, setIsLoading] = useState(false);
  const [ProfileTypes] = useState([
    { id: "HR_ADMIN", name: "HR Admin" },
    { id: "EMPLOYEE_SELF_SERVICE", name: "Employee self-service" },
    { id: "MANAGER_SELF_SERVICE", name: "Manager self-service" },
    { id: "CX_ADMIN", name: "CX Admin" },
  ]);

  useEffect(() => {
    setProfile(
      JSON.parse(atob(window.localStorage.getItem("SelectedProfile")))
    );
    let ProfileToEdit = JSON.parse(
      atob(window.localStorage.getItem("SelectedProfile"))
    );
    document.getElementById("name").value = ProfileToEdit.name;
    document.getElementById("Description").value = ProfileToEdit.description;
    window.localStorage.setItem("Type", ProfileToEdit.roleType);
    document.getElementById("name").focus();
    document.getElementById("Description").focus();
    handlePrevType(ProfileToEdit);
  }, []);
  const handlePrevType = (ProfileToEdit) => {
    ProfileTypes.map((Type) => {
      if (Type.id === ProfileToEdit.roleType) {
        window.localStorage.setItem("TypeName", Type.name);
        document.getElementById("pre-selected-type").innerHTML = Type.name;
        document.getElementById("type-filter").value = Type.id;
        document
          .getElementById("option-" + Type.id + "type")
          .classList.add("pre-selected");
      }
    });
  };
  const handleInputChange = () => {
    enableSave();
  };
  const handleSwitchChange = () => {
    enableSave();
  };
  const disableSaveBtn = () => {
    document.getElementById("save-btn").classList.add("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 0); // 1 means true, 0 means false
    setChangesApplied(false);
  };
  const enableSave = () => {
    document.getElementById("save-btn").classList.remove("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 1); // 1 means true, 0 means false
    setChangesApplied(true);
  };
  const cancelOperation = () => {
    if (ChangesApplied) {
      setUnsavedChanges(true);
    } else {
      window.localStorage.removeItem("CreatedProfileId");
      window.localStorage.removeItem("CreatedProfileNameString");
      window.localStorage.removeItem("CreatedProfileDesc");
      window.localStorage.removeItem("Enabled");
      window.localStorage.removeItem("HasErrors");
      window.location.assign("/home/securityProfiles");
    }
  };
  const discardAndLeave = () => {
    window.location.assign("/home/securityProfiles");
  };
  const saveAndLeave = () => {
    save();
    setUnsavedChanges(false);
  };
  const save = () => {
    setIsLoading(true);
    let Req = {
      method: "PUT",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/role",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        description: document.getElementById("Description").value,
        name: document.getElementById("name").value,
        id: SelectedProfile.id,
        roleType: document.getElementById("type-filter").value,
      },
    };
    if (document.getElementById("status-switch-holder").classList.length > 1) {
      Req.data.enabled = false;
    } else {
      Req.data.enabled = true;
    }
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setProfile(Res.data);
        let ProfileObject = JSON.stringify(Res.data);
        let ProfileBase64 = Buffer.from(ProfileObject).toString("base64");
        window.localStorage.setItem("SelectedProfile", ProfileBase64);
        window.localStorage.setItem("Enabled", Req.data.enabled);
        window.localStorage.setItem("HasErrors", 0); // set to false
        window.localStorage.setItem("Type", Res.data.roleType);
        disableSaveBtn();
        setIsLoading(false);
      })
      .catch((Err) => {
        console.log(Err.response);
        displayValidationError(Err.response.data.messages);
        setIsLoading(false);
      });
  };
  const displayValidationError = (ErrorText) => {
    if (ErrorText[0] === "Duplicate name") {
      setValidationError(translateText("duplicate_name_error"));
    }
    document.getElementById("name-label-holder").classList.add("wrong");
    setTimeout(() => {
      document.getElementById("name-label-holder").classList.remove("wrong");
    }, 3000);
  };
  const validateEntries = () => {
    let Name = document.getElementById("name").value;
    let IsActive;
    if (document.getElementById("status-switch-holder").classList.length > 1) {
      IsActive = false;
    } else {
      IsActive = true;
    }
    if (Name.length <= 0) {
      showEmptyNameError();
      window.localStorage.setItem("HasErrors", 1); //0:false 1:true
    } else {
      save();
    }
  };
  const showEmptyNameError = () => {
    setValidationError(translateText("fill_the_field_error"));
    document.getElementById("name-label-holder").classList.add("wrong");
  };
  const showEmptyDescError = () => {
    document
      .getElementById("Description-textarea-holder")
      .classList.add("wrong");
    setTimeout(() => {
      document
        .getElementById("Description-textarea-holder")
        .classList.remove("wrong");
    }, 3000);
  };
  const closeAlert = () => {
    setUnsavedChanges(false);
  };
  const handleTypeChange = () => {
    enableSave();
    document
      .getElementById("type-select")
      .classList.remove("cx-select-error-shown");
  };
  return (
    <React.Fragment>
      {UnsavedChanges ? (
        <UnsavedChangesAlert
          close={() => closeAlert()}
          saveAndLeave={() => saveAndLeave()}
          discardAndLeave={() => discardAndLeave()}
          LangData={props.LangData}
        />
      ) : null}
      <div className="form">
        <section className="form-header">
          <button className="return" onClick={() => cancelOperation()}>
            <i className="feather-arrow-left"></i>
          </button>
          {SelectedProfile.name ? (
            <h1>{SelectedProfile.name}</h1>
          ) : (
            <h1>{translateText("new_profile")}</h1>
          )}
          <div className="action-btn-group">
            <button onClick={() => cancelOperation()} className="cancel">
              {translateText("cancel")}
            </button>
            {IsLoading ? (
              <button
                onClick={() => null} //this button is disabled and won't act when loading is set to true
                id="save-btn"
                className="save no-action"
              >
                <img alt="" className="rotator" src={Rotator} />
              </button>
            ) : (
              <button
                onClick={() => validateEntries()}
                id="save-btn"
                className="save disabled"
              >
                {translateText("save")}
              </button>
            )}
          </div>
        </section>
        <div className="row">
          <p className="name">
            {translateText("name")} <p className="required">*</p>
          </p>
          <SimpleTextInput
            ChangeEvent={() => handleInputChange("name")}
            Id="name"
            PlaceHolder=""
            ValidationMessage={ValidationError}
          />
        </div>
        <div className="row">
          <p className="name">{translateText("status")}</p>
          {SelectedProfile.enabled === undefined ? null : (
            <Switch
              ChangeEvent={() => handleSwitchChange("status")}
              Id="status"
              IsActive={SelectedProfile.enabled}
            />
          )}
        </div>
        <div className="row">
          <p className="name">{translateText("type")}</p>
          <Select
            Initial={""}
            PreSelected
            PreSelectedId={window.localStorage.getItem("Type")}
            Options={ProfileTypes}
            IsWithId
            Id="type"
            ChangeHandler={() => handleTypeChange()}
            ValidationError={translateText("specify_type_error") + "."}
          />
        </div>
        <div className="row">
          <p className="name float-top">{translateText("description")}</p>
          <SimpleTextArea
            ChangeEvent={() => handleInputChange("Description")}
            Id="Description"
            PlaceHolder={translateText("optional")}
            ValidationMessage={translateText("fill_the_field_error") + "."}
          />
        </div>
      </div>
    </React.Fragment>
  );
};
export default BasicSettings;
